import React from 'react';
import { Github, Twitter, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
export function Footer() {
  const {
    language
  } = useLanguage();
  const t = translations[language].footer;
  return <footer className="bg-gray-900 text-gray-300 py-12" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-84">
          <div className="md:col-span-2" data-id="element-85">
            <h3 className="text-white text-xl font-bold mb-4" data-id="element-86">
              AfriCard Compare
            </h3>
            <p className="text-gray-400 leading-relaxed max-w-md" data-id="element-87">
              {t.description}
            </p>
          </div>

          <div data-id="element-88">
            <h4 className="text-white font-semibold mb-4" data-id="element-89">{t.legal}</h4>
            <ul className="space-y-2" data-id="element-90">
              <li data-id="element-91">
                <a href="/terms" onClick={e => {
                e.preventDefault();
                window.location.href = '/terms';
              }} className="hover:text-white transition-colors" data-id="element-92">
                  {t.terms}
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:text-white transition-colors" data-id="element-94">
                  {t.privacy}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-95">
            <h4 className="text-white font-semibold mb-4" data-id="element-96">{t.connect}</h4>
            <div className="flex gap-4" data-id="element-97">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors" data-id="element-98">
                <Twitter className="w-5 h-5" data-id="element-99" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors" data-id="element-100">
                <Github className="w-5 h-5" data-id="element-101" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors" data-id="element-102">
                <Mail className="w-5 h-5" data-id="element-103" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center text-gray-400 text-sm" data-id="element-104">
          <p data-id="element-105">
            © {new Date().getFullYear()} AfriCard Compare. {t.copyright}
          </p>
          <p className="mt-2" data-id="element-106">{t.disclaimer}</p>
        </div>
      </div>
    </footer>;
}